import { createSlice } from "@reduxjs/toolkit";

const LoginSlice = createSlice({
  name: "admin",
  initialState: {
    Admin: null,
    stores: null,
    partners: null,
  },
  reducers: {
    LoginSuccess: (state, action) => {
      state.Admin = action.payload;
    },
    StoresSuccess: (state, action) => {
      state.stores = action.payload;
    },
    PartnersSuccess: (state, action) => {
      state.partners = action.payload;
    },
    Logout: (state) => {
      state.Admin = null;
      state.store = null;
      state.partners = null;
    },
  },
});

export const { LoginSuccess, Logout, StoresSuccess, PartnersSuccess } =
  LoginSlice.actions;
export default LoginSlice.reducer;
